module.exports = __webpack_public_path__ + "static/Secureframe-5383aa7854b453935d041204d3eb64cf.jpg";